@if(loading()) {
<div class="link-preview-container link-preview-container--loading">
    <div class="link-preview-container__skeleton"></div>
</div>
}

@if(!loading() && !error() && preview()) {
    <div class="link-preview-container" (click)="openLink()">
        <div class="link-preview">
            @if(preview()?.image && !imageError()) {
                <div class="link-preview__image-container">
                    <img class="link-preview__image" [src]="preview()?.image" [alt]="preview()?.title || 'Preview'" loading="lazy" (error)="onImageError()" />
                </div>
            }
            <div class="link-preview__content">
                @if(preview()?.title) {
                    <h4 class="link-preview__title">{{ preview()?.title | htmlDecode }}</h4>
                }
                @if(preview()?.description) {
                    <p class="link-preview__description">{{ preview()?.description | htmlDecode }}</p>
                }
            </div>
        </div>
        <div class="link-preview__url">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M1.33333 12C0.966667 12 0.652778 11.8694 0.391667 11.6083C0.130556 11.3472 0 11.0333 0 10.6667V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H6V1.33333H1.33333V10.6667H10.6667V6H12V10.6667C12 11.0333 11.8694 11.3472 11.6083 11.6083C11.3472 11.8694 11.0333 12 10.6667 12H1.33333ZM4.46667 8.46667L3.53333 7.53333L9.73333 1.33333H7.33333V0H12V4.66667H10.6667V2.26667L4.46667 8.46667Z" />
            </svg>

            <span> {{ getDisplayUrl() }} </span>
        </div>
    </div>

}

<!-- HRS-2435: when the metadata endpoint returns nothing/fails, still render a
     minimal clickable card so the link is never lost from the response. -->
@if(!loading() && (error() || !preview())) {
    <div class="link-preview-container link-preview-container--fallback" [class.link-preview-container--reserved]="hadSkeleton()" (click)="openLink()">
        <div class="link-preview__url">
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M1.33333 12C0.966667 12 0.652778 11.8694 0.391667 11.6083C0.130556 11.3472 0 11.0333 0 10.6667V1.33333C0 0.966667 0.130556 0.652778 0.391667 0.391667C0.652778 0.130556 0.966667 0 1.33333 0H6V1.33333H1.33333V10.6667H10.6667V6H12V10.6667C12 11.0333 11.8694 11.3472 11.6083 11.6083C11.3472 11.8694 11.0333 12 10.6667 12H1.33333ZM4.46667 8.46667L3.53333 7.53333L9.73333 1.33333H7.33333V0H12V4.66667H10.6667V2.26667L4.46667 8.46667Z" />
            </svg>

            <span> {{ getDisplayUrl() }} </span>
        </div>
    </div>
}